// extracted by mini-css-extract-plugin
export default {"cls1":"YoFx2ch93fS5O5MobEI0","cls2":"HHgH3a2_J7Vrrstiam6g YoFx2ch93fS5O5MobEI0"};